import type { EditVehicleDocumentForm } from '@/modules/vehicles'
import { subWeeks } from 'date-fns'

/**
 * A document's expiration date is optional and only exists to notify about, so
 * both it and the notification time are cleared when the user turns the
 * notification off. The notification time is stored as an absolute timestamp
 * but entered as "weeks before the expiration date". Expirations, whose date is
 * required, build their input with `getVehicleExpirationInput` instead.
 */
export function getExpirationAndNotificationTime(
  form: EditVehicleDocumentForm,
  hasNotification: boolean
) {
  const expirationDate = !hasNotification ? null : form.expirationDate
  const notificationTime =
    !hasNotification || !expirationDate || !form.notificationTime
      ? null
      : subWeeks(expirationDate, form.notificationTime)

  return { expirationDate, notificationTime }
}
